// extracted by mini-css-extract-plugin
export default {"container":"SharedScss_container__I2KKR","card":"SharedScss_card__fviAy","header":"SharedScss_header__IEJnt","filler":"SharedScss_filler__mi-lt"};